export default{
    Red: 1,
    Green: 2,
    Blue: 3,
    Yellow: 4,
    Gray: 5
}